"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBlockGroupCollidingBlockGroup = void 0;
const blockwise_1 = require("./index");
/**
 * Check if a group of block is colliding with a group of blocks.
 *
 * @includeExample ./src/is-block-group-colliding-block-group.example.ts
 */
function isBlockGroupCollidingBlockGroup(a, b) {
    return a.some((block) => (0, blockwise_1.isBlockGroupColliding)(b, block));
}
exports.isBlockGroupCollidingBlockGroup = isBlockGroupCollidingBlockGroup;
